var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showSecretKey
    ? _c(
        "div",
        { staticClass: "eu-mt_4" },
        [
          _vm.showLimitedAlert
            ? _c("alert-limit-key", {
                attrs: { limit: _vm.MAX_LIMIT_KEYS_PER_ACCOUNT },
              })
            : _vm._e(),
          _c(
            "emd-card",
            { staticClass: "_footer_spaced_sm", attrs: { noBorder: "" } },
            [
              _c(
                "emd-card-header",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "actions",
                        fn: function () {
                          return [
                            _vm.showButtonCreate
                              ? _c("emd-button", {
                                  attrs: {
                                    color: "success",
                                    text: _vm.$t("button-create"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.isModalCreate = !_vm.isModalCreate
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2044829183
                  ),
                },
                [
                  _c(
                    "div",
                    { staticClass: "eu-display_flex eu-column" },
                    [
                      _c("emd-text", { attrs: { size: "section" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("api-keys")) + " "),
                      ]),
                      _c("doc-key"),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "emd-card-content",
                {
                  attrs: { customClass: "emd-table-responsive eu-no-padding" },
                },
                [
                  _vm.isLoadingSecretKeysList
                    ? _c(
                        "div",
                        { staticClass: "eu-pa_6 eu-align_center" },
                        [_c("emd-loader", { attrs: { type: "_invert" } })],
                        1
                      )
                    : _c("Table", {
                        attrs: { fields: _vm.tableFields, items: _vm.items },
                        on: { delete: _vm.handleOpenModalDelete },
                      }),
                  _vm.showEmptyList
                    ? _c("empty-list", {
                        attrs: { entity: "secretKeys", svg: "no-results" },
                      })
                    : _vm._e(),
                  !_vm.isLoadingSecretKeysList
                    ? _c("pagination", {
                        attrs: {
                          type: "list",
                          action: _vm.GET_SECRET_KEY_ACTION,
                          pagination: _vm.pagination,
                          totalShowing: _vm.totalItems,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isModalCreate
            ? _c("modal-create-key", {
                on: {
                  success: _vm.handleSuccessCreate,
                  handleClose: () => (_vm.isModalCreate = false),
                },
              })
            : _vm._e(),
          _vm.isModalCopy
            ? _c("modal-copy-key-content", {
                attrs: { secretKey: _vm.secretKey.key },
                on: { handleClose: () => (_vm.isModalCopy = false) },
              })
            : _vm._e(),
          _vm.isModalDelete
            ? _c("modal-delete-key-content", {
                attrs: { secretKey: _vm.secretKey },
                on: {
                  success: _vm.handleGetItems,
                  handleClose: () => (_vm.isModalDelete = false),
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }